import { httpClientCoreQuery } from '@/api/http-client';
import { TablePaginatedData } from '@/common/components/table/v2/interfaces';
import { EntitiesList } from '@/common/models';
import { FluentFilterCollection, Operator } from '@/common/services';
import { CoreQuery } from '@/common/services/core-query';
import { UserTopic } from '../models';
import { FilterProperties } from '../pages/all-courses-overview/overview-filters';

// TODO remove and refactor its usages
export function getUserTopics(topicIds?: number[]) {
    const filter = new FluentFilterCollection();
    if (topicIds) {
        const selectedTopicsId = topicIds?.join('|');
        selectedTopicsId && filter.where(FilterProperties.topicId).filter(Operator.IsEqualTo, selectedTopicsId);
    }

    const q = new CoreQuery()
        .entity([EntitiesList.LEARNING, EntitiesList.PERSONA, EntitiesList.COURSE, EntitiesList.TOPIC])
        .param({ page_size: 150 })
        .filters(filter);

    return httpClientCoreQuery.get<TablePaginatedData<UserTopic>>(q).then(({ data }) => data);
}
